<template>
  <div class="max-w-3xl mx-auto px-4 py-8">
    <h1 class="text-3xl font-bold mb-6 text-center">Публичная оферта АртМандала</h1>
    <section class="mb-8">
    <h2 class="text-2xl font-bold mb-4">1. Общие положения</h2>
    <p class="mb-4">
      Настоящая публичная оферта (далее - Оферта) является предложением Чаминой Ольги Николаевны, самозанятой, ИНН 720504321950 (далее - Исполнитель), заключить договор на изложенных ниже условиях с любым лицом, заинтересованным в получении услуг (далее - Пользователь).
    </p>
    <p class="mb-4">
      Акцептом настоящей Оферты является совершение Пользователем следующих действий:
    </p>
    <ul class="list-disc list-inside mb-4">
      <li>Регистрация на Сервисе с указанием персональных данных;</li>
      <li>Оплата услуг Сервиса.</li>
    </ul>
  </section>

  <section class="mb-8">
    <h2 class="text-2xl font-bold mb-4">2. Предмет договора</h2>
    <p class="mb-4">
      Исполнитель обязуется предоставить Пользователю доступ к Сервису АртМандала на условиях, предусмотренных настоящей Офертой. Сервис предоставляет уникальный подход к Мандалам Сети Света, включая:
    </p>
    <ul class="list-disc list-inside mb-4">
      <li>Возможность скачивать наборы мандал;</li>
      <li>Бесплатный расчет паттерна для вашего намерения;</li>
      <li>Обучение методике построения мандал;</li>
      <li>Создание индивидуального набора мандал в электронном виде.</li>
    </ul>
  </section>

  <section class="mb-8">
    <h2 class="text-2xl font-bold mb-4">3. Стоимость услуг и порядок оплаты</h2>
    <p class="mb-4">
      Стоимость услуг указывается на Сервисе и может быть изменена Исполнителем в любое время в одностороннем порядке. Оплата производится в форме 100% предоплаты за выбранный период доступа к Сервису. Все расчеты производятся в российских рублях.
    </p>
  </section>

  <section class="mb-8">
    <h2 class="text-2xl font-bold mb-4">4. Права и обязанности сторон</h2>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <h3 class="font-semibold mb-2">Исполнитель обязуется:</h3>
        <ul class="list-disc list-inside mb-4">
          <li>Предоставить Пользователю доступ к Сервису после оплаты;</li>
          <li>Обеспечить функционирование Сервиса 24 часа в сутки;</li>
          <li>Сохранять конфиденциальность информации Пользователя.</li>
        </ul>
      </div>
      <div>
        <h3 class="font-semibold mb-2">Пользователь обязуется:</h3>
        <ul class="list-disc list-inside mb-4">
          <li>Предоставить достоверную информацию при регистрации;</li>
          <li>Не передавать свои учетные данные третьим лицам;</li>
          <li>Использовать Сервис только в личных некоммерческих целях.</li>
        </ul>
      </div>
    </div>
  </section>
</div>

</template>

<script setup>
// Component logic can be added here if needed
</script>
